import { PlusIcon } from '@heroicons/react/24/outline';
import TaskIcon from '@plato/ui-legacy/assets/icons/task-icon';
import { Button } from '@plato/ui-legacy/components/ui/button';
import { Page } from '@plato/ui-legacy/components/ui/page';
import { PageHeader } from '@plato/ui-legacy/components/ui/page-header';
import * as Accordion from '@radix-ui/react-accordion';
import { useTranslation } from 'react-i18next';
import { TaskOverviewFilters } from '../components/task-overview-filters.tsx';
import { TaskEmptyContent } from '../components/task-overview-table/task-empty-content.tsx';
import { TaskOverviewGroup } from '../components/task-overview-table/task-overview-group.tsx';
import { useShowCreateTaskDialog } from '../hooks/use-show-create-task-dialog.ts';

export function TaskOverviewPage() {
    const { t } = useTranslation();
    const showCreateTaskDialog = useShowCreateTaskDialog();

    const handleNewTaskClick = () => {
        showCreateTaskDialog({ source: 'task_overview_page' });
    };

    return (
        <Page>
            <PageHeader
                icon={TaskIcon}
                subTitle={t('page_sub_title__tasks')}
                actions={
                    <Button variant="primary" onClick={handleNewTaskClick} icon={PlusIcon}>
                        {t('top_navbar__new_task')}
                    </Button>
                }
                title={t('page_title__tasks')}
            />
            <TaskOverviewFilters />
            <div className="flex flex-col gap-4 overflow-y-auto">
                <Accordion.Root type="multiple" defaultValue={['today', 'upcoming']}>
                    <TaskOverviewGroup group="today" />
                    <TaskOverviewGroup group="upcoming" />
                    <TaskOverviewGroup group="completed" />
                </Accordion.Root>
            </div>
            <TaskEmptyContent />
        </Page>
    );
}
